import React, { FC, useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';
import { Button, InputField } from '../index';
import { API } from '../../api';

// Create Chain restaurants
const ChainEditUserModal: FC<any> = (props) => {
  const [userId, setUserId] = useState<string | number>('');
  const [username, setUsername] = useState<string>('');
  const [password1, setPassword1] = useState<string>('');
  const [password2, setPassword2] = useState<string>('');

  useEffect(() => {
    if (!props.user) return;

    setUserId(props.user?.id);
    setUsername(props.user?.username);
  }, [props]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (password1 !== password2) {
      toast.error("Password don't match", { containerId: 'B' });
      return;
    }

    if (!username || !password1 || !password2) {
      toast.error('Please, fill in all the fields', { containerId: 'B' });
      return;
    }

    // Create Restaurant here
    const formData = new FormData();

    formData.append('username', username);
    formData.append('password', password1);

    API.restaurantApi
      .updateChainUser(props.user.id, formData)
      .then((res) => {
        toast.success('User updated', { containerId: 'B' });
        clearFields();
        props.toggle();
      })
      .catch((err) => {
        console.log('err', err);
        toast.error('User was not updated', { containerId: 'B' });
      });
  };

  const clearFields = () => {
    setUsername('');
    setPassword1('');
    setPassword2('');
  };

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    clearFields();
    props.toggle && props.toggle();
  };

  return (
    <Modal isOpen={props.modal} toggle={handleCancel}>
      <ModalHeader toggle={props.toggle}>Bewerk user #{userId}</ModalHeader>
      <form onSubmit={(e) => handleSubmit(e)}>
        <ModalBody>
          <div className="form-group text-left">
            <label htmlFor="" className="small">
              E-mail
            </label>
            <InputField
              required
              type="email"
              name="username"
              placeholder="email"
              value={username}
              onChange={(e: any) => setUsername(e.target.value)}
            />
          </div>

          <div className="form-group text-left">
            <label htmlFor="" className="small">
              Wachtwoord
            </label>
            <InputField
              required
              type="password"
              name="password1"
              placeholder="Wachtwoord"
              pattern=".{8,}"
              value={password1}
              onChange={(e: any) => setPassword1(e.target.value)}
            />
            <small id="password_help" className="form-text text-muted">
              minimum 8 characters
            </small>
          </div>

          <div className="form-group text-left">
            <label htmlFor="" className="small">
              Bevestig wachtwoord
            </label>
            <InputField
              required
              type="password"
              name="password2"
              placeholder="Bevestig wachtwoord"
              pattern=".{8,}"
              value={password2}
              onChange={(e: any) => setPassword2(e.target.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button name="Cancel" btnLongWidth={false} onClick={handleCancel} type="button" />
          <Button name="Save" type="submit" dangerButton={true} btnLongWidth={false} />
        </ModalFooter>
      </form>
    </Modal>
  );
};
export default ChainEditUserModal;
